<template>
  <div class="flex-column">
    <div class="contact-detail-header px-1 py-2 d-flex justify-content-between align-items-center" style="background-color: #FAFAFA;">
      <div class="px-3" style="color: #696B72; font-size: 16px; font-weight: 700;">
        Nhật ký hoạt động
      </div>
      <div class="d-flex">
        <el-select @change="changeEm" v-model="selectedEm" filterable default-first-option
                 placeholder="Tìm kiếm tài khoản..."
                 class="flex-1" style="max-width: 160px">
        <el-option label="Tất cả tài khoản" value=""></el-option>
        <el-option v-for="em in employees" :key="em.username" :label="em.username"
                   :value="em.username"></el-option>
      </el-select>
      <el-select v-model="selectedType" @change="typeChange()" class=" mx-2" style="width: 160px;">
        <el-option v-for="item in types" :key="item.val" :label="item.name"
                   :value="item.val">
        </el-option>
      </el-select>
      </div>
    </div>
    <div class="divider-custom" />
    <div class="contact-item-list">
      <div class="" v-for="(request,index) in items" :key="index">
        <div class="d-flex p-2 fw-bold font-size-15" v-if="index==0" style="color: #9497A5;">
          <div class="me-2" style="width: 25vw; padding-left: 13px; ">Thông tin</div>
          <div class="flex-1 text-center">Phản hồi từ zalo</div>
          <div class="zalo-account-list-item-3 text-center">Phân loại</div>
          <div class="zalo-account-list-item-3 text-center">Người gửi</div>
        </div>
        <div class="divider-custom" />
        <div class="d-flex p-3 font-size-15">
          <div style="width: 25vw; ">
            <div class="d-flex" style="margin-top: 2px">
              <el-avatar :size="52" :src="request.avatar"></el-avatar>
              <div class="flex-1 mx-3">
                <div class="font-size-16 fw-semibold text-1-line" style="font-weight: 700;">{{ request.name }}</div>
                <div class="font-size-14 fw-normal mt-2" style="color: #9497A5;">Thời gian gửi :
                  {{ formatDateTimeShort(Number(request.timestamp + "000")) }}
                </div>
              </div>
            </div>
          </div>
          <div class="flex-1 py-3 text-center">
            {{ getMessage(request.response, request.type) }}
          </div>
          <div class="zalo-account-list-item-3 text-center pt-3">
            <TagCustom :item="getTypeDisplay(request.type)" :selected="false"/>
          </div>
          <div class="zalo-account-list-item-3 text-center pt-3">
            {{ request.swUsername }}
          </div>
        </div>
        <div class="divider-custom " />
      </div>
    </div>
    <div class="d-flex justify-content-center  mt-2">
      <el-pagination
        v-if="pageInfo.total > 1"
        background
        layout="prev, pager, next"
        :current-page="pageInfo.page"
        :total="pageInfo.total"
        :page-size="pageInfo.pageSize"
        @current-change="currentRequestPageChanged"
        @prev-click="pageInfo.page -= 1"
        @next-click="pageInfo.page += 1"
      ></el-pagination>

    </div>
  </div>
</template>

<script>
import TagCustom from "@/components/common/TagCustom";

export default {
  name: "LogFriendRequest",
  components: { TagCustom },
  props: ["selectedAccount"],
  watch: {
    selectedAccount: function() {
      this.pageInfo.page = 1;
      this.getLogs();
    }
  },
  data() {
    return {
      employees: [],
      selectedEm: "",
      pageInfo: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      selectedType: "all",
      items: [],
      types: [
        { val: "all", name: "Tất cả hoạt động", color: "#1A6B44" },
        { val: "accept", name: "Đồng ý kết bạn", color: "#1A6B44" },
        { val: "reject", name: "Từ chối kết bạn", color: "#CF4547" },
        { val: "undo", name: "Thu hồi lời mời", color: "#CF4547" },
        { val: "send", name: "Gửi kết bạn", color: "#1A6B44" },
        { val: "remove", name: "Xóa bạn", color: "#CF4547" },
        { val: "block", name: "Chặn tin nhắn", color: "#CF4547" },
        { val: "unblock", name: "Bỏ chặn tin nhắn", color: "#1A6B44" }
      ]
    };
  },
  methods: {
    getMessage(response, type) {
      let data = JSON.parse(response);
      if (data.error_code == 0) {
        return this.types.filter(p => p.val == type)[0].name + " thành công";
      }
      return data.error_message;
    },
    currentRequestPageChanged(newPage) {
      this.pageInfo.page = newPage;
      this.getLogs();
    },
    changeEm() {
      this.getLogs();
    },
    typeChange() {
      this.getLogs();
    },
    getTypeDisplay(type) {
      return this.types.filter(p => p.val == type)[0];
    },
    getLogs() {
      this.items = [];
      let body = {
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
        accountId: this.selectedAccount,
        type: this.selectedType,
        swUsername: this.selectedEm
      };
      this.$http.post("/api/log", body).then((resp) => {
        let data = resp.data;
        this.app.contactTotal.log = data.totalElement;
        this.pageInfo.total = data.totalElement;
        this.items.push(...data.content);
      });
    },
    getEmployeeList() {
      this.$http.get("/api/employee/all").then(val => {
        this.employees = val.data;
        let filter = this.employees.filter((e) => e.username == this.app.user.swUsername);
        if (filter == null || filter.length == 0) {
          this.employees.push({ username: this.app.user.swUsername, accounts: this.accounts });
        }
      });
    }
  },
  created() {
    this.getEmployeeList();
  }
};
</script>

<style scoped>

</style>
